import { render, staticRenderFns } from "./HomeWishlistFR.vue?vue&type=template&id=1e2860fe&scoped=true"
import script from "./HomeWishlistFR.vue?vue&type=script&lang=js"
export * from "./HomeWishlistFR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2860fe",
  null
  
)

export default component.exports